import { render, staticRenderFns } from "./block-credit.vue?vue&type=template&id=923af6bc&scoped=true&"
import script from "./block-credit.vue?vue&type=script&lang=js&"
export * from "./block-credit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923af6bc",
  null
  
)

export default component.exports